import { takeEvery, takeLatest } from "redux-saga/effects";

import {
  FIND_IFLOW_PROCESSES_BY_FILTERS,
  GET_IFLOW_FORMDATA,
  POST_IFLOW_FORMDATA,
  GET_IFLOW_DOCUMENT,
  SUBSTITUTE_IFLOW_DOCUMENT,
  GET_IFLOW_METADATA_PREVIEW,
} from "../ducks/processes/actionTypes";

import {
  findIflowProcessesByFilters,
  getIflowFormdata,
  postIflowFormData,
  getIflowDocument,
  substituteIflowDocument,
  getIflowMetadataPreview,
} from "../ducks/processes/sagas";

export const processesSagas = [
  takeLatest(FIND_IFLOW_PROCESSES_BY_FILTERS, findIflowProcessesByFilters),
  takeLatest(GET_IFLOW_FORMDATA, getIflowFormdata),
  takeLatest(POST_IFLOW_FORMDATA, postIflowFormData),
  takeEvery(GET_IFLOW_DOCUMENT, getIflowDocument),
  takeEvery(SUBSTITUTE_IFLOW_DOCUMENT, substituteIflowDocument),
  takeLatest(GET_IFLOW_METADATA_PREVIEW, getIflowMetadataPreview),
];
